import React, { useEffect } from 'react';
import { Map } from './components/Map';
import { SettingsPanel } from './components/SettingsPanel';
import { RouteEditor } from './components/RouteEditor';
import { UserPanel } from './components/UserPanel';
import { UserLocationPanel } from './components/UserLocationPanel';
import { JsonViewer } from './components/JsonViewer';
import { RouteTogglePanel } from './components/RouteTogglePanel';
import { useStore } from './store';
import { routeManager } from './lib/routeManager';

function App() {
  const { activePanel } = useStore();

  // アプリ起動時にルートデータを読み込む
  useEffect(() => {
    routeManager.loadFromStorage();
  }, []);

  return (
    <div className="w-full h-screen relative bg-gray-100">
      {/* 地図は常に表示するが、ユーザー位置情報は地図モードの時のみ表示 */}
      <Map showUserLocations={activePanel === 'map'} />
      
      {/* 設定パネル */}
      <SettingsPanel />
      
      {/* 各種パネル */}
      {activePanel === 'settings' && (
        <div className="absolute left-4 top-4 bg-white p-4 rounded-lg shadow-lg w-96">
          <RouteEditor />
        </div>
      )}
      
      {activePanel === 'users' && (
        <div className="absolute left-4 top-4">
          <UserPanel />
        </div>
      )}
      
      {activePanel === 'map' && (
        <>
          <div className="absolute left-4 top-4">
            <UserLocationPanel />
          </div>
          <RouteTogglePanel />
        </>
      )}
      
      {/* JSON Viewer */}
      <JsonViewer />
    </div>
  );
}

export default App;